import React, { useState, useMemo } from 'react'
import { View, StyleSheet } from 'react-native'
import { ViewPager, Icon, Text, useTheme } from '@ui-kitten/components'
import { useTranslation } from 'react-i18next'

export default function ReviewsSlider({ reviews, withBackground = false }) {
  const [reviewIndex, setReviewIndex] = useState(0)
  const { t } = useTranslation()
  const theme = useTheme()
  const localizedReviews = useMemo(() => {
    return reviews.map(review => ({
      ...review,
      name: t('funnel.reviewName' + review.id),
      text: t('funnel.reviewText' + review.id),
    }))
  }, [reviews])

  return (
    <ViewPager style={styles.viewPager} selectedIndex={reviewIndex} onSelect={setReviewIndex} useNativeDriver={true}>
      { localizedReviews.map((review, index) => (
        <View key={review.id} style={[styles.page, withBackground ? [styles.withBackground, { backgroundColor: theme['background-basic-color-1'] }] : {}]}>
          <View style={{ flexDirection: 'row', justifyContent: 'center', marginBottom: 5 }}>
            {Array(5).fill().map((_, i) => (
              <Icon key={i} name='star' width={20} height={20} fill='#FFD700' />
            ))}
          </View>
          <Text style={styles.reviewText} category='s2'>{review.text}</Text>
          <Text style={styles.reviewName} appearance='hint' category='c1'>{review.name}</Text>
        </View>
      ))}
    </ViewPager>
  )
}

const styles = StyleSheet.create({
  viewPager: {
    // flex: 1,
    alignSelf: 'stretch',
    marginBottom: 10
  },
  page:{
    // flex: 1,
    alignItems: 'center',
    // marginTop: 50
    justifyContent: 'center',
    maxWidth: 600,
    alignSelf: 'center'
  },
  withBackground: {
    padding: 20,
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  reviewText: {
    marginBottom: 5,
    paddingHorizontal: 20,
    textAlign: 'center'
  },
  reviewName: {
    paddingHorizontal: 20,
    textAlign: 'center'
  },
})
